var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0001 3.99999C10.7158 3.99999 4.00008 10.7157 4.00008 19C4.00008 27.2843 10.7158 34 19.0001 34C27.2844 34 34.0001 27.2843 34.0001 19C34.0001 10.7157 27.2844 3.99999 19.0001 3.99999ZM0.666748 19C0.666748 8.87477 8.87486 0.666656 19.0001 0.666656C29.1253 0.666656 37.3334 8.87477 37.3334 19C37.3334 29.1252 29.1253 37.3333 19.0001 37.3333C8.87486 37.3333 0.666748 29.1252 0.666748 19ZM17.3334 12.3333C17.3334 11.4128 18.0796 10.6667 19.0001 10.6667H19.0167C19.9372 10.6667 20.6834 11.4128 20.6834 12.3333C20.6834 13.2538 19.9372 14 19.0167 14H19.0001C18.0796 14 17.3334 13.2538 17.3334 12.3333ZM19.0001 17.3333C19.9206 17.3333 20.6667 18.0795 20.6667 19V25.6667C20.6667 26.5871 19.9206 27.3333 19.0001 27.3333C18.0796 27.3333 17.3334 26.5871 17.3334 25.6667V19C17.3334 18.0795 18.0796 17.3333 19.0001 17.3333Z",
    fill: "#0061D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutline);
export default __webpack_public_path__ + "static/media/infoOutline.ab35262d52010b8be851e9e71ed2ebbe.svg";
export { ForwardRef as ReactComponent };